export default __webpack_public_path__ + "static/media/step2.4dd028d6.svg";